export function errorToString(error: unknown, fallback: string): string {
  return error instanceof Error ? error.toString() : typeof error === "string" ? error : fallback;
}

export function errorMessage(error: unknown, fallback: string): string {
  return error instanceof Error ? error.message : typeof error === "string" ? error : fallback;
}
